module.exports = __webpack_public_path__ + "img/partner8.e5537d73.png";